import React from 'react';
import PropTypes from 'prop-types';

import './TabBase.css'

class TabBase extends React.Component {

	constructor() {
		super();

		this._elemTotalPulses = React.createRef();
		this._elemTotalDuration = React.createRef();

		this._elemVisualisation = React.createRef();
		this._elemChargeDelay = React.createRef();

		this._elemAdjustedPowerOutput = React.createRef();
		this._elemPulsesPerSecond = React.createRef();

		this._powerOutput = null; // this is null on the 

	}

	values() {
		var retVal = {};
		retVal.adjustedPowerOutput = this._adjustedPowerOutput;
		retVal.powerOutput = this._powerOutput;
		retVal.chargeDelay = this._elemChargeDelay.current.isEnabled() ? this._chargeDelay : null;
		retVal.pulsesPerSecond = this._pulsesPerSecond;
		return retVal;
	}

	setValues(values) {

		//console.log('setValues', values);
		
		if (undefined !== values.adjustedPowerOutputHighlight) { this._elemAdjustedPowerOutput.current.setHighlight(values.adjustedPowerOutputHighlight); }
		if (undefined !== values.chargeDelayHighlight) { this._elemChargeDelay.current.setHighlight(values.chargeDelayHighlight); }
		if (undefined !== values.pulsesPerSecondHighlight) { this._elemPulsesPerSecond.current.setHighlight(values.pulsesPerSecondHighlight); }

		if (undefined !== values.adjustedPowerOutput) { this._elemAdjustedPowerOutput.current.setValue(values.adjustedPowerOutput); this.setAdjustedPowerOutput(values.adjustedPowerOutput); }

		if ((undefined === values.chargeDelay) || (null === values.chargeDelay)) {
			this._elemChargeDelay.current.setChecked(false);
		} 
		else {
			this._elemChargeDelay.current.setChecked(true);
			this._elemChargeDelay.current.setValue(values.chargeDelay); this.setChargeDelay(values.chargeDelay);
		}

		if (undefined !== values.pulsesPerSecond) { this._elemPulsesPerSecond.current.setValue(values.pulsesPerSecond); this.setPulsesPerSecond(values.pulsesPerSecond); }

		// Clear after load
		this.setNonFormikInputsTouched(false);
	}

	setPulsesPerSecond(value) {

		const oldStep = this.calculatePulsesPerSecondStep(this._pulsesPerSecond);
		const step = this.calculatePulsesPerSecondStep(value);
		
		//console.log(`TabBase.setPulsesPerSecond step : value=${value} step=${oldStep}-->${step}`);

		if (oldStep !== step) {
			// console.log(`TabBase.setPulsesPerSecond step : ${oldStep} --> ${step}`);
			this._elemPulsesPerSecond.current.setStep(step);
		}
		
		this._pulsesPerSecond = value;

		this.setNonFormikInputsTouched(true);
	}

	setAdjustedPowerOutput(value) {
		this._elemVisualisation.current.setAdjustedPowerOutput(value);
		this._adjustedPowerOutput = value;

		this.setNonFormikInputsTouched(true);
	}
	onChangeAdjustedPowerOutput = (value) => {
		this.setAdjustedPowerOutput(value);

		this.setPowerOutput(null);
	}

	setPowerOutput(value) {
		this._elemVisualisation.current.setPowerOutput(value);
		this._powerOutput = value;

		this.setNonFormikInputsTouched(true);
	}
	onChangePowerOutput = (value) => {
		this.setPowerOutput(value);
	}

	setChargeDelay(value) {
		this._elemVisualisation.current.setChargeDelay(value);
		this._chargeDelay = value;

		this.setNonFormikInputsTouched(true);
	}
	onChangeChargeDelay = (value) => {
		this.setChargeDelay(value);
	}

	onChangeChargeDelayIsEnabled = (isEnabled) => {
		if (isEnabled) {
			this.setChargeDelay(this._chargeDelay);
		}
		else {
			this._elemVisualisation.current.setChargeDelay(null);
		}
	}
	updateTotalDuration() {
		this._elemTotalDuration.current.setValue(this.calculateTotalDuration());
	}

	updateTotalPulses() {
		this._elemTotalPulses.current.setValue(this.calculateTotalPulses());
	}

	// https://lucidgroup.assembla.com/spaces/magstim/tickets/realtime_list?ticket=1635
	// PDM - Usability - Warning dialogue when trying to navigate away from with unsaved data.
	// This prop can be set so that the tabs can call back to the parent to set the nonFormikInputsTouched flag
	setNonFormikInputsTouched(value){
		if(this.props.nonFormikInputsTouched !== null && this.props.nonFormikInputsTouched !== undefined){
			this.props.nonFormikInputsTouched(value);
		}
	}

}

TabBase.propTypes = {
    displayMT: PropTypes.bool
};

TabBase.defaultProps = {
    displayMT: false
};

export default TabBase;